import angular from 'angular';
import quotationsModule from './quotations/quotations';
import serviceOrdersModule from './service-orders/service-orders';
import paymentOrdersModule from './payment-orders/payment-orders';
import paymentBillsModule from './payment-bills/payment-bills';
import paymentCartModule from './payment-cart/payment-cart';

let paymentsAdvancesModule = angular.module('app.paymentsAdvances',[
  quotationsModule.name,
  serviceOrdersModule.name,
  paymentOrdersModule.name,
  paymentBillsModule.name,
  paymentCartModule.name
]);

export default paymentsAdvancesModule;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/payments-advances/payments-advances.js
 **/